import "styles/common"
import "init/styles/application.scss"

import "components/radio-button"
import "components/toggle-button"
import "components/weather-icon"
import "components/temp-value"

import { SignUp } from "components/signup"

import { WindIcon } from "components/wind-icon"
import initSwellIcons from "components/swell-icon"
import { TempValue } from "components/temp-value"
import tideTable from "components/tide-table"
import switchUnits from "components/switch-units"
import { loadTides } from "utils/tide/tides"
import Units from "utils/units" // eslint-disable-line import/no-named-as-default
import DomLoaded from "utils/dom-loaded"
import PageLoaded from "utils/page-loaded"
import initHotjarKeystrokeRecording from "utils/hotjar-allow-keystrokes"
import "fc-ads/fc-ads.scss"
import init from "init/application"
import statistics from "components/statistics"
import tooltip from "components/tooltip"
import forecastTable from "components/forecast-table"
import langSelector from "components/lang-selector"
import scrollButton from "components/scroll-button/scroll-button"
import "components/carousel/carousel"
import "components/breakheader"
import "components/guideheader"
import "components/seo-section"
import "components/guide-page"
import "components/forecast-cta"
import "components/nearby-points"
import "components/t-shirt-comp"
import "components/print-link"
import "components/join-incentives"
import "components/signup-prompts"
import { SurfBreakWebcams } from "components/surf-break-webcams"
import { WebcamPopup } from "components/webcam-popup"
import "components/page-footer"
import "components/print-header"
import "components/language-flags"
import "components/country-flag"
import "components/star-rating"
import "components/wave-energy"
import "components/resort-webcams/static/no-webcam.jpg"
import { WebcamSuggestionForm } from "components/webcam-suggestion-form"
import "components/app-store"
import "components/app-buttons"
import "components/sea-temp"
import "components/profile"
import "components/alert-table"
import "components/main-page-header"
import "components/page-header-small"
import "components/password"
import "components/login"
import "components/buttons"
import "components/outside-buttons"
import "components/apple-buttons"
import "components/google-buttons"
import "components/homepage-hero"
import "components/outside-promo-page"
import "components/outside-page"
import "components/subscribe"
import "components/icon"
import { PageHeader } from "components/page-header"
import { LocationSubheader } from "components/location-subheader"
import forecastUserControl from "components/forecast-user-control"
import { GreenroomArticles } from "components/greenroom-articles"
import { Tweets } from "components/tweets"
import { BreakHeader } from "components/breakheader"
import { Smartbar } from "components/smartbar"
import tidesDot from "components/tides-dot"
import resortWebcams from "components/resort-webcams"
import alertForm from "components/alert-form"
import { Leaflet } from "components/leaflet"
import { TidesCountdown } from "components/tides-countdown"
import { SignupPage } from "components/signup-page"
import { Nearby } from "components/nearby"
import { MapNodesDebug } from "components/map-nodes-debug"
import { WebcamMap } from "components/webcam-map"
import { TabNavigationComponent } from "components/profile"
import { Banner } from "components/questionnaire-banner"
import galleryPhoto from "components/gallery-photo"
import { FeatureNewsPosts, RowNewsPosts, TaggedNewsPost } from "components/news-posts"
import "components/wind-state"
import { SurfForecastTable } from "components/surf-forecast-table"
import { ForecastTextSummary, RegionTextSummary } from "components/text-summaries"
import initForecastSummarySessionRecording from "components/text-summaries/session-recording"
import waveGraphScale from "components/wave-graph-scale"
import "components/user-avatar"
import { ToggleSearchMode } from "components/location-nav"
import "components/temp-diff"
import "components/discount-pages"
import "components/affiliate-bar"

import "static"
import "styles/overrides.scss"

const meta = document.querySelector("meta[name=csrf-token]")
const token = meta ? meta.content : ""

DomLoaded(() => {
  init()
  initHotjarKeystrokeRecording()
  statistics()
  tooltip()
  forecastTable()
  langSelector()
  scrollButton()
  resortWebcams()
  WebcamSuggestionForm.init(document.body)
  MapNodesDebug()
  galleryPhoto({
    token,
    loggedIn: window.FCGON?.logged_in || false,
    memberMode: window.FCGON?.member_mode || false,
    location: window.FCGON?.location_filename,
  })

  switchUnits()
  loadTides()
  tideTable(window.FCGON || {})
  alertForm()
  WindIcon.init(document, {})
  initSwellIcons(document, Units)
  TempValue.init(document.body)
  Smartbar.init(document.body)
  TabNavigationComponent.init(document.body)
  Banner.init(document.body)
  PageHeader.init(document.body)
  SignupPage.init(document.body)
  GreenroomArticles.init(document.body)
  new SignUp(null, undefined)
  TidesCountdown.init(document)
  FeatureNewsPosts.init(document.body)
  RowNewsPosts.init(document.body)
  TaggedNewsPost.init(document.body)
  SurfForecastTable.init(document.body)
  ForecastTextSummary.init(document.body)
  RegionTextSummary.init(document.body)
  initForecastSummarySessionRecording()
  waveGraphScale(document)
  forecastUserControl()
  LocationSubheader.init(document.body)
  ToggleSearchMode.init(document.body)

  if (document.body.classList.contains("js-units-i")) {
    Units.change({
      temperature: "Imperial",
      length: "Imperial",
      speed: "Imperial",
    })
  }

  const switchSurfUnits = (newUnits) => {
    const val = newUnits === "i" ? "Imperial" : "Metric"
    Units.change({ temperature: val, length: val, speed: val })
  }
  window.switchSurfUnits = switchSurfUnits

  Units.onChange((changes) => {
    if (!window.unitsConv || !changes) return

    if (
      changes.temperature === "Imperial" ||
      changes.length === "Imperial" ||
      changes.speed === "Imperial"
    ) {
      window.unitsConv.switchFCUnits("i")
    } else if (
      changes.temperature === "Metric" ||
      changes.length === "Metric" ||
      changes.speed === "Metric"
    ) {
      window.unitsConv.switchFCUnits("m")
    }
  })

  if (window.FCGON && window.FCGON.maps) {
    Leaflet.init(document.body, window.FCGON.maps)
  }

  if (window.FCGON && window.FCGON.webcam_maps) {
    WebcamMap.init(document.body, window.FCGON.webcam_maps)
  }

  WebcamPopup.init(document.body)
  SurfBreakWebcams.init(document.body)
  Nearby.init(document.body, {})
  Tweets.init(document.body)
  BreakHeader.init(document.body)
})

PageLoaded(() => {
  tidesDot()
  document.body.classList.add("loaded")
})
